/**
 * The @api registry — every backend call goes through the KORM contract at
 * POST /api/crud/:Model. Named entries exist for ergonomics and to keep the
 * request bodies in one auditable place; `crud` is the generic door.
 */
const stripModel = ({ model, ...rest }) => rest;
const post = (model, body) => ({ url: `/api/crud/${model}`, method: 'POST', data: body });

export default {
  // --- authentication --------------------------------------------------------
  login: (data) => post('User', { action: 'login', data }),
  logout: () => post('User', { action: 'logout' }),
  me: () => post('User', { action: 'me' }),
  changePassword: (data) => post('User', { action: 'changePassword', data }),

  // --- products --------------------------------------------------------------
  // where: { q, category, status, expiry_state, warehouse_id }
  productOverview: (body = {}) => post('Product', { action: 'overview', ...body }),
  productStats: (body = {}) => post('Product', { action: 'stats', ...body }),
  productDetail: (id) => post('Product', { action: 'detail', where: { id } }),
  productCategories: () => post('Product', { action: 'categories' }),
  // The one-field edit the app is built around.
  productUpdateExpiry: (data) => post('Product', { action: 'updateExpiry', data }),
  // Stock out the current batch and (optionally) receive the replacement.
  // Omit `expiry_date` to stock out without reordering.
  productRestock: (data) => post('Product', { action: 'restock', data }),
  productHistory: (id) => post('Product', { action: 'history', where: { id } }),
  // The photo travels inline as a data URL — see client/src/lib/image.js.
  productUploadImage: (data) => post('Product', { action: 'uploadImage', data }),
  productClearImage: (product_id) => post('Product', { action: 'clearImage', data: { product_id } }),

  // --- warehouse -------------------------------------------------------------
  warehouseCurrent: () => post('Warehouse', { action: 'current' }),
  warehouseSummary: () => post('Warehouse', { action: 'summary' }),

  // Generic: fetchApi('crud', { model:'Product', action:'list', where:{...} })
  crud: (body) => post(body.model, stripModel(body)),
};
